import { cn } from '@/lib/utils/cn.js';
import type { ReactNode } from 'react';

export type TagTone = 'primary' | 'new' | 'hot' | 'jackpot';

export interface TagProps {
  tone?: TagTone;
  children: ReactNode;
  className?: string;
}

const TONE_MAP: Record<TagTone, string> = {
  primary: 'bg-[var(--primary)] text-[var(--primary-on)]',
  new:     'bg-[var(--info)] text-white',
  hot:     'bg-[var(--danger)] text-white',
  jackpot: 'bg-gradient-to-b from-[var(--warning)] to-[#b45309] text-[#1a1100]',
};

export function Tag({ tone = 'primary', children, className }: TagProps) {
  return (
    <span
      className={cn(
        'absolute top-2 right-2 rounded-md px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide',
        TONE_MAP[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
